<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        isShowClose: {
            type: Boolean,
            default: false,
        },
    },
    name: "popup",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        // 弹窗显示/隐藏监听
        show: {
            handler(val) { 
                if(val){
                    document.body.style.overflow = 'hidden';
                }else{
                    document.body.style.overflow = 'auto';
                }
            },
            immediate: true
        },
    },
    methods: {},
};
</script>

<template>
    <div class="popup" v-if="show">
        <div class="in flex flex_column">
            <div class="top flex align_center justify_between">
                <p class="title">{{ title }}</p>
                <div class="btn_close" v-if="isShowClose" @click="$emit('close')"></div>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
.popup{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: .7);
    z-index: 999;
    .in{
        width: 8.6rem;
        background: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: .3rem;
        @media screen and (max-width: 750px) {
            width: 100%;
            top: auto;
            bottom: 0;
            left: 0;
            transform: none;
            border-top-left-radius: .3rem;
            border-top-right-radius: .3rem;
            background: #efefef;
            animation: slideUp .3s ease forwards;
        }
        @keyframes slideUp {
            0% {
                bottom: -100%;
            }
            100% {
                bottom: 0;
            }
        }
        .top{
            margin-bottom: .3rem;
            .title{
                margin-bottom: 0;
            }
            .btn_close{
                width: .3rem;
                height: .3rem;
                position: relative;
                cursor: pointer;
                &::before, &::after{
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 100%;
                    height: 1px;
                    background-color: #000;
                }
                &::before{
                    transform: translate(-50%, -50%) rotate(45deg);
                }
                &::after{
                    transform: translate(-50%, -50%) rotate(-45deg);
                }
            }
        }
    }
    .btn_group{
        gap: .15rem;
        @media screen and (max-width: 750px) {
            justify-content: center;
        }
    }
    .btn{
        height: .3rem;
        padding: 0 .1rem;
        font-size: .16rem;
        border: 1px solid var(--font_color);
        border-radius: .05rem;
        cursor: pointer;
        line-height: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        // 禁止文本被选中
        user-select: none;
        &.disabled{
            // color: #bbbbbb;
            opacity: .6;
            cursor: auto;
        }
        &.active{
            color: #fff;
            background: #666;
            border-color: #666;
            cursor: auto;
        }
        &.big{
            height: .4rem;
            padding: .2rem;
        }
        @media screen and (max-width: 750px) {
            &,
            &.big{
                flex: 1;
                height: .6rem;
                font-size: .25rem;
                border: none;
                background: #fff;
                border-radius: .1rem;
            }
        }
    }
}
</style>